/* eslint-disable import/no-anonymous-default-export */
import axios from 'axios';
import { API_URL, APIV, apikey,API_VERSION_V2 } from '../../src/config/constant';
import secureStorage from '../config/encrypt';
import * as HELPER from "../../src/config/helper";
import maintenanceManager from '@src/utils/maintenanceManager';
import MaintenanceService from '@src/services/MaintenanceService';


// import { toast } from 'react-toastify';
const Axios = axios.create();
const activeRequestControllers = new Set<AbortController>();

const isBlockedByMaintenance = (url?: string): boolean =>
    maintenanceManager.isUnderMaintenance() && !MaintenanceService.isStatusRequest(url);

const getMaintenanceBlockedResponse = (): any => ({
    status: 503,
    data: maintenanceManager.getBlockedResponse(),
});

const blockIfUnderMaintenance = (url?: string): Promise<any> | null =>
    isBlockedByMaintenance(url) ? Promise.resolve(getMaintenanceBlockedResponse()) : null;

const abortActiveRequests = () => {
    activeRequestControllers.forEach((controller) => controller.abort());
    activeRequestControllers.clear();
};

maintenanceManager.subscribe((state) => {
    if (state.isUnderMaintenance) abortActiveRequests();
});

Axios.interceptors.request.use(
    (config) => {
        if (isBlockedByMaintenance(config.url)) {
            return Promise.reject({
                __maintenanceBlocked: true,
                response: getMaintenanceBlockedResponse(),
            });
        }

        const controller = new AbortController();
        config.signal = config.signal || controller.signal;
        (config as any).__maintenanceController = controller;
        activeRequestControllers.add(controller);

        return config;
    },
    (error) => Promise.reject(error),
);

Axios.interceptors.response.use(
   async (response) => {  
        activeRequestControllers.delete((response.config as any)?.__maintenanceController);

        if(response && response.headers && response.headers["isresponseencrypted"] && +response.headers["isresponseencrypted"] === 1){
            let iv = response.headers['responseiv'];
            let symmetricKey = response.headers['responseaeskey'];   
            response.data = HELPER.decryptResponseData(response.data?.encryptedData,iv,symmetricKey);
            // debugger; 
            
        }
        if (maintenanceManager.isMaintenanceResponse(response?.data, response?.status, response?.headers)) {
            maintenanceManager.applyResponse(response?.data, response?.status, response?.headers);
        }
         
        return response;
    },
    (error) => {
        activeRequestControllers.delete((error.config as any)?.__maintenanceController);

        if (error?.__maintenanceBlocked) {
            return error.response;
        }

        if (axios.isCancel(error) && maintenanceManager.isUnderMaintenance()) {
            return getMaintenanceBlockedResponse();
        }

        // handle error
        if (error.response) {
            if (
                +error.response.status === 503 ||
                maintenanceManager.isMaintenanceResponse(error.response?.data, error.response?.status, error.response?.headers)
            ) {
                maintenanceManager.applyResponse(error.response?.data, error.response?.status, error.response?.headers);
            } else if (+error.response.status === 401) {
                secureStorage.removeItem('authUserInfo');
                window.location.href = '/login';
            } else if (+error.response.status === 400) {
            }

        }

        return error.response;
    });

// (window as any).commonErrorToast = function (error: any) {
//     if (typeof error == "string") toast.error(error);
//     else if (error.message) toast.error("Helllo", error.message);
// }

let isEncryptionOn = secureStorage.getItem('is_encryption_on');


const MasterSerive = {

    getToken() {
        return (secureStorage.getItem('authUserInfo') && secureStorage.getItem('authUserInfo')['token'])
            ? secureStorage.getItem('authUserInfo')['token']
            : ''
    },
    delete(URL: string, body: object, headers: any) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        const blockedResponse = blockIfUnderMaintenance(URL);
        if (blockedResponse) return blockedResponse;
        return Axios.delete(`${API_URL.GETWAY_API}${URL}`, { data: body, headers })
    },
    post: async(URL: string, body?: object, headers?: any) => { 
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = MasterSerive.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['x-api-version'] = API_VERSION_V2
 
        if(URL === "/common/uploadAndReadDocument"){
            headers['apikey'] = apikey;
        }        
        headers['Isresponseencrypted'] = 1;
        
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        const blockedResponse = blockIfUnderMaintenance(URL);
        if (blockedResponse) return blockedResponse;

        // let encryptedData: any = {body, headers}
        let encryptedData: any = (isEncryptionOn && URL.indexOf("getPublicKey") === -1) ? await HELPER.encryptRequestData(URL, headers, body) : {body, headers}   
        return Axios.post(`${API_URL.GETWAY_API}${URL}`, encryptedData?.body, { headers: encryptedData.headers })
    },
    put(URL: string, body?: object, headers?: any) {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = this.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        const blockedResponse = blockIfUnderMaintenance(URL);
        if (blockedResponse) return blockedResponse;
        return Axios.put(`${API_URL.GETWAY_API}${URL}`, body, { headers })
    },
    get: async(URL: string, query?: any, headers?: any) => {
        headers = headers || {};
        if (APIV) headers['apiv'] = APIV;
        headers['Authorization'] = MasterSerive.getToken();
        headers['Accept-Language'] = secureStorage.getItem('lang') || 'en';
        headers['x-api-version'] = API_VERSION_V2 

        // headers['apikey'] = apikey;
        URL = (URL[0] === '/') ? URL.substring(1) : URL;
        const blockedResponse = blockIfUnderMaintenance(URL);
        if (blockedResponse) return blockedResponse;

        // let encryptedData: any = {body: query, headers}

        let encryptedData: any = (isEncryptionOn && URL.indexOf("getPublicKey") === -1) ? await HELPER.encryptRequestData(URL, headers, query) : {body: query, headers}

        return Axios.get(`${API_URL.GETWAY_API}${URL}`,
            { params: encryptedData.body, headers: encryptedData.headers })
    }
}

export default MasterSerive;
